import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "xl:w-1/2 hidden xl:block px-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainContent = _resolveComponent("MainContent")!

  return (_ctx.showDesktopDoctorCard)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_MainContent, { paddingClass: "py-6 px-6" }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("div", {
              id: "checkout-summary-panel",
              class: "space-y-6"
            }, null, -1),
            _createElementVNode("div", {
              id: "checkout-debug-panel",
              class: "mt-6 space-y-6"
            }, null, -1)
          ]))]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}